/**
 * File: routes.js
 * Origin: isotect
 * Description: File contains all application routes.
 *
 * Version: v1.3.0
 * Created: 2025-11-12
 * Last Updated: 2026-06-22
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Base Paths
const AUTH_BASE = "/auth";
const HOME_BASE = "/";
const PROD_BASE = "/products";
const SERV_BASE = "/services";
const USER_BASE = "";

// Routes
export const routes = {
    public: {
        auth: {
            root: AUTH_BASE,
            signIn: { rel: "sign-in", abs: `${AUTH_BASE}/sign-in` },
            signUp: { rel: "sign-up", abs: `${AUTH_BASE}/sign-up` },
            recovery: { rel: "recovery", abs: `${AUTH_BASE}/recovery` },
            reset: { rel: "reset", abs: `${AUTH_BASE}/reset` },
            verify: { rel: "verify", abs: `${AUTH_BASE}/verify` },
        },

        home: {
            root: HOME_BASE,
        },

        products: {
            root: PROD_BASE,
            flowkit: { rel: "flowkit", abs: `${PROD_BASE}/flowkit` },
            isocheck: { rel: "isocheck", abs: `${PROD_BASE}/isocheck` },
            nameplate: { rel: "nameplate", abs: `${PROD_BASE}/nameplate` },
            tecthub: { rel: "tecthub", abs: `${PROD_BASE}/tecthub` },
        },

        services: {
            root: SERV_BASE,
            drafting: { rel: "drafting", abs: `${SERV_BASE}/drafting` },
            engineering: {
                rel: "engineering",
                abs: `${SERV_BASE}/engineering`,
            },
            qaqc: { rel: "qaqc", abs: `${SERV_BASE}/qaqc` },
            surveying: { rel: "surveying", abs: `${SERV_BASE}/surveying` },
        },
    },

    user: {
        root: USER_BASE,
        dashboard: { rel: "dashboard", abs: `/dashboard` },
        orders: { rel: "orders", abs: `/orders` },
    },
};
